import {HttpHeaders} from "@angular/common/http";

export class HttpUtils {

  public static buildOptions(params: any) {
    return {
      headers: new HttpHeaders({'Content-Type': 'application/json'}),
      params: params
    };
  }

  public static buildListParams(offset?: number, limit?: number) {
    if (offset != null && limit != null) {
      return {
        offset: offset.toString(),
        limit: limit.toString()
      };
    }
    return {};
  }

}
